/**
 * Textos (`ca`) del tall «suppliers» de Qualitat i APPCC (OBR-166, homologació de proveïdors). Tall propi: no es
 * toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const suppliersCa = {
  'backoffice.qualitySuppliers': {
    // Estats de homologació (llista, filtre, historial, avisos).
    statusPending: 'Pendent',
    statusApproved: 'Homologat',
    statusNotApproved: 'No homologat',
    statusSuspended: 'Suspès',

    // Llista de proveïdors: columna i filtre.
    colHomologation: 'Homologació',
    filterHomologation: 'Homologació',
    filterAll: 'Tots els estats',
    rowHomologation: 'Homologació',

    // Secció «Homologació» del diàleg del proveïdor.
    sectionTitle: 'Homologació',
    sectionHint:
      'L’estat de confiança del proveïdor, els seus documents i com ha anat canviant. Un proveïdor que no és homologat és un avís a la comanda i a la recepció, mai un bloqueig.',
    sectionNewHint: 'Es podrà homologar el proveïdor un cop l’hagis desat.',
    sectionLoadError: 'No s’ha pogut carregar la homologació d’aquest proveïdor.',
    dialogTitle: 'Homologació de {{name}}',
    dialogClose: 'Tanca',
    currentStatus: 'Estat actual',
    statusDate: 'Data',
    statusBy: 'Responsable',
    statusNeverChanged: 'Encara no s’ha decidit',
    statusUnknownPerson: 'Persona desconeguda',
    readOnlyHint: 'L’estat només el pot canviar l’administració o qualitat.',

    // Canviar l’estat (motiu obligatori).
    changeStatus: 'Canvia l’estat',
    changeTitle: 'Canvia l’estat de homologació',
    changeBody:
      'El proveïdor passa de «{{from}}» a l’estat que triïs. El canvi i el motiu queden a l’historial i no es poden esborrar.',
    changeTarget: 'Nou estat',
    changeReasonLabel: 'Motiu del canvi (obligatori)',
    changeReasonPlaceholder: 'Per què canvia: auditoria feta, certificat caducat, incidència greu…',
    changeConfirm: 'Canvia l’estat',
    changeErrorForbidden: 'No tens permís per canviar l’estat de homologació.',
    changeErrorReason: 'Cal escriure el motiu del canvi.',
    changeErrorNotFound: 'Aquest proveïdor ja no existeix o està de baixa.',
    changeError: 'No s’ha pogut canviar l’estat. Torna-ho a provar.',

    // Observacions.
    notesLabel: 'Observacions',
    notesHint: 'Condicions, resultat de l’auditoria… Es desen a part de la resta de la fitxa, amb el seu propi botó.',
    notesSave: 'Desa les observacions',
    notesSaved: 'Observacions desades.',
    notesError: 'No s’han pogut desar les observacions. Torna-ho a provar.',

    // Historial de canvis d’estat.
    historyTitle: 'Historial de canvis',
    historyEmpty: 'Encara no s’ha registrat cap canvi d’estat.',
    historyWhen: 'Quan',
    historyFrom: 'De',
    historyTo: 'A',
    historyReason: 'Motiu',
    historyWho: 'Qui',

    // Documents.
    documentsTitle: 'Documents',
    documentsHint: 'El registre sanitari (RGSEAA) i, si en té, certificats com IFS, BRC o ecològic.',
    documentsEmpty: 'Encara no hi ha cap document.',
    documentsLoadError: 'No s’han pogut carregar els documents.',
    documentsReadOnlyHint: 'Els documents només els poden gestionar l’administració, qualitat i compres.',
    addDocument: 'Afegeix un document',
    editDocument: 'Edita',
    deleteDocument: 'Dona de baixa',
    openFile: 'Obre el fitxer',
    openFileFor: 'Obre el fitxer de {{name}}',
    openFileError: 'No s’ha pogut obrir el fitxer. Torna-ho a provar.',
    colDocName: 'Document',
    colDocIssued: 'Emissió',
    colDocExpires: 'Caducitat',
    colDocState: 'Estat',
    colDocFile: 'Fitxer',
    colDocActions: 'Accions',
    docTypeSanitaryRegistry: 'Registre sanitari',
    docTypeCertificate: 'Certificat',
    noFile: 'Sense fitxer',

    // Caducitat d’un document.
    expiryValid: 'Vigent',
    expiryExpiring: 'Caduca aviat',
    expiryExpired: 'Caducat',
    expiryNone: 'Sense caducitat',
    expiryExpiringIn_one: 'Caduca d’aquí a {{count}} dia',
    expiryExpiringIn_other: 'Caduca d’aquí a {{count}} dies',
    expiryExpiringToday: 'Caduca avui',
    expiryExpiredAgo_one: 'Va caducar fa {{count}} dia',
    expiryExpiredAgo_other: 'Va caducar fa {{count}} dies',

    // Diàleg d’un document.
    docAddTitle: 'Afegeix un document',
    docEditTitle: 'Edita el document',
    docType: 'Tipus',
    docName: 'Nom',
    docNameHint: 'Per exemple: RGSEAA, IFS, BRC, Ecològic.',
    docNumber: 'Número',
    docIssued: 'Data d’emissió',
    docExpires: 'Data de caducitat',
    docExpiresHint: 'Deixa-ho en blanc si el document no caduca.',
    docNotes: 'Notes',
    docFile: 'Fitxer',
    docFileHint: 'PDF o imatge, fins a 10 MB.',
    docFileCurrent: 'Fitxer desat: {{name}}',
    docFileChosen: 'Fitxer triat: {{name}}',
    docSave: 'Desa el document',
    docErrorName: 'Cal un nom per al document.',
    docErrorDates: 'La data de caducitat no pot ser anterior a la d’emissió.',
    docErrorInvalidType: 'El fitxer ha de ser un PDF o una imatge.',
    docErrorTooLarge: 'El fitxer supera els 10 MB.',
    docErrorUpload: 'No s’ha pogut pujar el fitxer. Torna-ho a provar.',
    docErrorSave: 'No s’ha pogut desar el document. Torna-ho a provar.',
    docErrorNoTenant: 'No s’ha pogut saber a quin obrador pertany el fitxer. Torna a entrar.',

    // Baixa d’un document (motiu obligatori).
    docDeleteTitle: 'Dona de baixa el document',
    docDeleteBody:
      'El document deixa de veure’s a la fitxa del proveïdor, però queda a l’historial. Cal escriure’n el motiu.',
    docDeleteConfirm: 'Dona de baixa',
    docDeleteError: 'No s’ha pogut donar de baixa el document. Torna-ho a provar.',

    // Avisos que no bloquegen (comanda, enviament, recepció).
    warnOrderPending:
      'Aquest proveïdor encara no està homologat (estat pendent). Pots continuar, però convé decidir-ne la homologació.',
    warnOrderNotApproved:
      'Aquest proveïdor no està homologat. Pots continuar, però revisa si és el proveïdor que vols fer servir.',
    warnOrderSuspended:
      'Aquest proveïdor està suspès. Pots continuar, però revisa si és el proveïdor que vols fer servir.',
    warnReceptionNotApproved:
      'Aquest proveïdor no està homologat. Pots registrar la recepció igualment, però revisa el gènere amb atenció.',
    warnReceptionSuspended:
      'Aquest proveïdor està suspès. Pots registrar la recepció igualment, però revisa el gènere amb atenció.',
  },
} as const;
